import camelize from 'camelcase-keys-deep';

export default class LotDocument {
  constructor(data) {
    const props = camelize(data);
    Object.assign(this, props);
  }

  document() {
    return this.env().Document.getById(this.documentId);
  }
}
